import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  createAppMetaInfo,
  deleteAppMetaInfo,
  deleteEnvironments,
  deleteEnvironmentsFailure,
  getAppMetaInfo,
  getAppSettings,
  getEnvironments,
  getEnvironmentsWithDb,
  getMemberApps,
  getSharedDbs,
  getTechnologyStack,
  getTechnologyStackBySuiteId,
  newEnvCreated,
  sentDeleteEnvironments,
  sentEnvironments,
  sentTeckStack,
  sentUpdateAppSettings,
  sentUpdateEnvironments,
  sentUpdateTeckStack,
  setAppMetaInfo,
  setAppSettings,
  setEnvironments,
  setMemberApps,
  setSharedDbs,
  setTechnologyStack,
  updateAppSettings,
  updateEnvironments,
  updateTechnologyStack,
  saveEnvironmentsSuccess,
  saveEnvironmentsFailure
} from '../actions/technologystack.actions';

@Injectable()
export class TechnologyStackEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getStackData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getTechnologyStack),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.appId;
          return this.baseService[action.apiConstants.method](apiConstants, GlobalConstants.dataTableHeaders).subscribe(
            (techStackData: any) => {
              if (techStackData) {
                this.store.dispatch(setTechnologyStack({ technologyStackData: techStackData }));
              } else {
                this.store.dispatch(setTechnologyStack({ technologyStackData: 'newForm' }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getStackDataBySuiteId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getTechnologyStackBySuiteId),
        map((action: any) => {
          return this.baseService[action.apiConstants.method](action.apiConstants, action.params).subscribe(
            (techStackData: any) => {
              if (techStackData) {
                this.store.dispatch(setTechnologyStack({ technologyStackData: techStackData }));
              } else {
                this.store.dispatch(setTechnologyStack({ technologyStackData: 'newForm' }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  getMemberAppsBySuiteId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getMemberApps),
        map((action: any) => {
          return this.baseService[action.apiConstants.method](action.apiConstants, action.params).subscribe(
            (memberApps: any) => {
              if (memberApps) {
                this.store.dispatch(setMemberApps({ memberApps: memberApps }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  saveStackData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentTeckStack),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.saveTechStackData).subscribe(
            (techStackData: any) => {
              // this.store.dispatch(saveTechnologyStack({ technologyStackData : techStackData}));
              this.store.dispatch(
                newEnvCreated({
                  createdEnv: techStackData
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  saveAppMetaInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createAppMetaInfo),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.appMetaInfoData).subscribe(
            (metaData: any) => {
              // this.store.dispatch(saveTechnologyStack({ technologyStackData : techStackData}));
              console.log('metaInfo created');
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  deleteAppMetaInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteAppMetaInfo),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.modelId).subscribe(
            (metaData: any) => {
              // this.store.dispatch(saveTechnologyStack({ technologyStackData : techStackData}));
              console.log('metaInfo deleted');
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getAppMetaInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAppMetaInfo),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((metaData: any) => {
            // this.store.dispatch(saveTechnologyStack({ technologyStackData : techStackData}));
            this.store.dispatch(setAppMetaInfo({ metaInfoData: metaData }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  updateStackData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentUpdateTeckStack),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            action.updateTechStackData
          ).subscribe((techStackData: any) => {
            this.store.dispatch(updateTechnologyStack({ technologyStackData: techStackData }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getSettingsData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAppSettings),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.appId;
          return this.baseService[action.apiConstants.method](apiConstants, GlobalConstants.dataTableHeaders).subscribe(
            (settingsData: any) => {
              if (settingsData) {
                this.store.dispatch(setAppSettings({ settingsData: settingsData }));
              } else {
                this.store.dispatch(setAppSettings({ settingsData: 'newForm' }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getSharedDbs$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getSharedDbs),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.suiteId;
          return this.baseService[action.apiConstants.method](apiConstants).subscribe((sharedDbs: any) => {
            if (sharedDbs) {
              this.store.dispatch(setSharedDbs({ sharedDbs: sharedDbs }));
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );

  updateSettingsData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentUpdateAppSettings),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            action.updateSettingsData
          ).subscribe((settingsData: any) => {
            this.store.dispatch(updateAppSettings({ settingsData: settingsData }));
          });
        })
      ),
    {
      dispatch: false
    }
  );
  getEnvironmentList$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getEnvironments),
        map((action: any) => {
          const query = action.searchFields;
          const apiConstants = { ...action.envapiConstants };
          apiConstants.url = action.envapiConstants.url + action.appId;
          return this.baseService[action.envapiConstants?.method](apiConstants, JSON.stringify(query)).subscribe(
            (envList: any) => {
              if (envList.results.length > 0) {
                this.store.dispatch(setEnvironments({ environmentDataList: envList.results }));
              } else {
                this.store.dispatch(setEnvironments({ environmentDataList: [] }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  getEnvironmentListWithDb$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getEnvironmentsWithDb),
        map((action: any) => {
          const apiConstants = { ...action.envapiConstants };
          return this.baseService[action.envapiConstants?.method](apiConstants, action.params).subscribe(
            (envList: any) => {
              if (envList.length > 0) {
                this.store.dispatch(setEnvironments({ environmentDataList: envList }));
              } else {
                this.store.dispatch(setEnvironments({ environmentDataList: [] }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  saveEnvData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentEnvironments),
        map((action: any) => {
          return this.baseService[action.envapiConstants?.method](
            action.envapiConstants,
            action.environmentData
          ).subscribe(
            (envData: any) => {
              this.store.dispatch(saveEnvironmentsSuccess());
            },
            (error: any) => {
              this.store.dispatch(saveEnvironmentsFailure({ error: error }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  updateEnvData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentUpdateEnvironments),
        map((action: any) => {
          return this.baseService[action.envapiConstants?.method](
            action.envapiConstants,
            action.updateEnvironment
          ).subscribe((updateEnvData: any) => {
            this.store.dispatch(updateEnvironments({ updateEnvironmentData: updateEnvData }));
          });
        })
      ),
    {
      dispatch: false
    }
  );

  deleteEnv$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sentDeleteEnvironments),
        map((action: any) => {
          const apiConstants = { ...action.envapiConstants };
          apiConstants.url = action.envapiConstants.url + action.envId;
          return this.baseService[action.envapiConstants?.method](apiConstants).subscribe(
            () => {
              return this.store.dispatch(
                deleteEnvironments({
                  envId: action.envId
                })
              );
            },
            (error: any) => {
              return this.store.dispatch(
                deleteEnvironmentsFailure({
                  envId: action.envId,
                  error: error
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
}
